exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,700);", ""]);

// module
exports.push([module.id, "@font-face {\n  font-family: 'Helvetica 35 Thin';\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Helvetica 35 Thin\"), url(" + require("assets/fonts/helvetica-neue/HelveticaNeue-Thin.woff") + ") format(\"woff\"); }\n\n.rebound-animation {\n  animation-name: _rebound-animation;\n  animation-duration: .5s;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n  animation-timing-function: ease-in-out; }\n\n@keyframes _rebound-animation {\n  0% {\n    top: 0px; }\n  100% {\n    top: 5px; } }\n\n.flicker {\n  animation-name: _flicker-animation;\n  animation-duration: 1s;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite; }\n\n.flicker-fast {\n  animation-name: _flicker-animation;\n  animation-duration: 0.4s;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite; }\n\n@keyframes _flicker-animation {\n  0% {\n    opacity: 1; }\n  50% {\n    opacity: 0.5; }\n  100% {\n    opacity: 1; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/administration/configuration/configuration.component.scss
// module id = 1939
// module chunks = 66